<div id="step1">
  <div class="videoPlain">
    <video #homeVideo loop muted autoplay playsinline preload="auto" data-wf-ignore="true" data-object-fit="cover"
      poster="https://d2z7yiz3wla4oq.cloudfront.net/videos/homepage_26.jpg">
      <source type="video/mp4" src="https://d2z7yiz3wla4oq.cloudfront.net/videos/homepage_26.mp4"
        data-wf-ignore="true" />
    </video>
  </div>

  <div class="center">
    <h1>
      <span [@fadeText]="animationTiming[0]">{{ 'homepage.step1.title.ride' | translate }}
      </span>
      <span [@fadeText]="animationTiming[1]">{{ 'homepage.step1.title.run' | translate }}
      </span>
      <span [@fadeText]="animationTiming[2]">{{
        'homepage.step1.title.row' | translate
        }}</span>
    </h1>
    <p [@fadeTextSlide]="animationTiming[3]">
      {{ 'homepage.step1.subtitle' | translate }}
    </p>
    <div class="btnGroup" [@fadeTextSlide]="animationTiming[3]">
      @if (!currentUser) {
      <a (click)="register()" class="btn-secondary">{{
        'homepage.step1.btnCreateAccount' | translate
        }}</a>
      }
      @if (currentUser) {
      <a [routerLink]="['/dashboard']" class="btn-secondary">
        <em class="fas fa-tachometer-alt"></em>&nbsp;{{
        'menu.dashboard' | translate
        }}
      </a>
      }
      <a routerLink="/get-started" class="btn-primary">{{
        'homepage.step1.btnGetStarted' | translate
        }}</a>
    </div>
  </div>

  @if (partnerImages?.length > 0) {
  <kin-brands-carousel class="carousel" [brandsImgSrc]="partnerImages" />
  }
</div>